<template>
  <div id="contenedor-listado-participantes-licitacion-mobile">
    <template v-for="(participante, index) in licitacionParticipantes">
      <v-card :key="index" class="mb-3">
        <v-card-title>
          {{ participante.contratista.nombreRazonSocial }}
          <v-spacer></v-spacer>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="editar(participante)">
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip> -->
          <v-tooltip
          v-if="mixValidaScopesActions(3)"
          top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="borrar(participante)">
                <v-icon> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>Borrar</span>
          </v-tooltip>
        </v-card-title>
      </v-card>
    </template>
  </div>
</template>

<script>
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoParticipantesLicitacionMobile',
  data() {
    return {};
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
  methods: {
    borrar(participanteLicitacion) {
      eventBus.$emit('eliminar-participante', participanteLicitacion);
    },
  },
};
</script>

<style lang="scss">
</style>
